// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ns-0";